module.exports = __webpack_public_path__ + "static/img/contant_2.9ec9fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_11/contant_2.jpg
// module id = Vp0Q
// module chunks = 0